import { css } from 'lit';
import { fsDesignToken } from '../../core/style-util.js';

export const style = css`
  .header-text {
    font-size: ${fsDesignToken('fsFontSizeMedium3')};
    font-weight: ${fsDesignToken('fsFontWeightSemibold')};
    line-height: 36px;
    margin-bottom: 1rem;
    margin-top: 0;
  }

  .iconic-container {
    margin-bottom: 24px;
    margin-left: auto;
    margin-right: auto;
    max-width: ${fsDesignToken('fsBreakpointMedium')};
    padding: 0 ${fsDesignToken('fsSizeSpacingMedium2')};

    @media (min-width: 768px) {
      max-width: ${fsDesignToken('fsBreakpointMedium')};
      padding: 0;
    }

    @media (min-width: ${fsDesignToken('fsBreakpointExtraLarge')}) {
      max-width: 768px;
    }
  }

  .marketing-offer {
    background-color: ${fsDesignToken('fsColorFeedbackInfoSecondary')};
    border-radius: ${fsDesignToken('fsRadiusMedium')};
    font-size: ${fsDesignToken('fsFontSizeMedium1')};
    font-weight: ${fsDesignToken('fsFontWeightSemibold')};
    padding: ${fsDesignToken('fsSizeSpacingMedium1')};
  }

  .return-cta {
    margin-top: 1em;
    text-align: center;
  }

  .return-cta-button {
    margin: 0 auto;
  }

  .cta-button {
    margin-top: 24px;
    width: 100%;

    @media (min-width: 768px) {
      display: flex;
      margin-left: auto;
      margin-right: auto;
      width: fit-content;
    }
  }
`;
